import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import useValue from "./useValue";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const { reset, handleSubmit, setErrors, setData, valueFields } = useValue();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('/attributes/values/' + id).then(res => {
      reset(res.data.value);
    });
  }, []);

  const editValue = data => {
    const formData = new FormData();

    axios.put('attributes/values/' + data.id, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Value has been updated successfully!', {
            icon: "success",
          });
          navigate(-1);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit value">
      <form className="form w-100 row" onSubmit={handleSubmit(editValue)}>
        {valueFields}
        <SubmitButton
          title="Update"
          classes="w-auto d-inline-block"
        />
      </form>
    </Card>
  );
}